import Link from "next/link";
import { getAffiliateMappingByAnalysisId } from "~/src/const/affiliate/analysisMapping";
import { getBookPageBySlug } from "~/src/const/affiliate/pages";

type AffiliateLinkProps = {
  analysisId: string;
};

/**
 * 分析記事に関連するアフィリエイトページへのリンク
 * 対応するアフィリエイトページがない場合は何も表示しない
 */
export default function AffiliateLink({ analysisId }: AffiliateLinkProps) {
  const affiliateMapping = getAffiliateMappingByAnalysisId(analysisId);

  if (!affiliateMapping) {
    return null;
  }

  const bookPage = getBookPageBySlug(affiliateMapping.slug);

  if (!bookPage) {
    return null;
  }

  return (
    <section className="pt-16">
      <h2 className="mb-3 text-lg font-bold md:mb-5 md:text-2xl">関連記事</h2>
      <p className="mb-4 text-sm leading-relaxed text-GRAY_1 md:text-base">
        {affiliateMapping.description}
      </p>
      <Link
        href={`/recommend/${affiliateMapping.slug}`}
        className="block rounded-lg border border-GRAY_3 bg-gradient-to-r from-WHITE_1 to-WHITE_2 p-6 transition-all hover:border-PRIMARY/30 hover:shadow-md"
      >
        <p className="mb-2 text-sm text-GRAY_1">{bookPage.date}</p>
        <h3 className="mb-3 text-base font-semibold text-BLACK_1 hover:text-PRIMARY md:text-lg">
          {bookPage.title}
        </h3>
        <p className="text-sm leading-relaxed text-GRAY_1">
          {bookPage.description}
        </p>
        <div className="mt-4">
          <span className="text-sm font-medium text-PRIMARY">詳しく見る →</span>
        </div>
      </Link>
    </section>
  );
}
